import { passengersCounterConfig } from './config';
import type {
  PassengersConstraints,
  PassengersList,
  PassengersState,
} from './types';

function getTotalPassengersAmount(passengersState: PassengersList) {
  const { adt, chd, inf, yth } = passengersState;

  return {
    totalAmount: adt + chd + inf,
    youthTotalAmount: yth,
  };
}

function isMaxDisabled(amount: number, maxAmount: number, totalAmount: number) {
  return (
    amount >= maxAmount ||
    totalAmount >= passengersCounterConfig.MAX_TOTAL_PASSENGERS_AMOUNT
  );
}

function isMinEnabled(amount: number, minAmount: number) {
  return amount <= minAmount;
}

function shouldInfantsDecrease(adt?: number, inf?: number) {
  return adt && inf ? inf > adt : false;
}

function getPassengersCounterState(passengersState: PassengersList) {
  type PassengersListKeys = keyof typeof passengersState;

  const { totalAmount, youthTotalAmount } =
    getTotalPassengersAmount(passengersState);
  return (Object.keys(passengersState) as Array<PassengersListKeys>).reduce(
    (acc, key) => {
      const passengersConstraints: PassengersConstraints =
        passengersCounterConfig.PASSENGERS_CONSTRAINTS;
      const constraints = passengersConstraints[key];
      const amount = passengersState[key];
      return {
        ...acc,
        [key]: {
          amount,
          isMinDisabled: isMinEnabled(amount, constraints.min),
          isMaxDisabled: isMaxDisabled(
            amount,
            key === 'inf' ? passengersState.adt : constraints.max,
            key === 'yth' ? youthTotalAmount : totalAmount,
          ),
        },
      };
    },
    {} as PassengersState,
  );
}

export const passengerCounterLib = {
  getPassengersCounterState,
  shouldInfantsDecrease,
};
